import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { FileText, DownloadSimple } from "@phosphor-icons/react";

export default function Reports() {
    const [vehicles, setVehicles] = useState([]);
    const [vehicleId, setVehicleId] = useState("");
    const [year, setYear] = useState(new Date().getFullYear());
    const [month, setMonth] = useState(new Date().getMonth() + 1);
    const [loading, setLoading] = useState("");

    useEffect(() => {
        api.get("/vehicles").then((r) => setVehicles(r.data));
    }, []);

    const generate = async (kind) => {
        setLoading(kind);
        try {
            const body = { kind };
            if (kind === "inspection_log" && vehicleId) body.vehicle_id = vehicleId;
            if (kind === "vehicle_card") body.vehicle_id = vehicleId;
            if (kind === "monthly") { body.year = year; body.month = month; }
            if (kind === "yearly") body.year = year;
            const res = await api.post("/reports", body, { responseType: "blob" });
            const url = URL.createObjectURL(res.data);
            window.open(url, "_blank");
            toast.success("PDFを生成しました");
        } catch {
            toast.error("PDF生成に失敗しました");
        } finally {
            setLoading("");
        }
    };

    const ReportCard = ({ kind, title, desc, needsVehicle, needsDate }) => (
        <div className="prc-card p-5" data-testid={`report-${kind}`}>
            <FileText size={24} />
            <h3 className="mt-3 font-semibold">{title}</h3>
            <p className="mt-1 text-sm text-[var(--prc-muted)]">{desc}</p>
            {needsVehicle && (
                <div className="mt-3">
                    <label className="prc-label-overline block mb-1">対象車両</label>
                    <select className="prc-input" value={vehicleId} onChange={(e) => setVehicleId(e.target.value)} data-testid={`report-${kind}-vehicle`}>
                        <option value="">{kind === "vehicle_card" ? "選択してください" : "全車両"}</option>
                        {vehicles.map((v) => <option key={v.id} value={v.id}>{v.plate_number}</option>)}
                    </select>
                </div>
            )}
            {needsDate && (
                <div className="mt-3 flex gap-2">
                    <div className="flex-1">
                        <label className="prc-label-overline block mb-1">年</label>
                        <input type="number" className="prc-input" value={year} onChange={(e) => setYear(parseInt(e.target.value))} data-testid={`report-${kind}-year`} />
                    </div>
                    {kind === "monthly" && (
                        <div className="w-24">
                            <label className="prc-label-overline block mb-1">月</label>
                            <input type="number" className="prc-input" min="1" max="12" value={month} onChange={(e) => setMonth(parseInt(e.target.value))} data-testid={`report-${kind}-month`} />
                        </div>
                    )}
                </div>
            )}
            <button
                onClick={() => generate(kind)}
                disabled={loading === kind || (kind === "vehicle_card" && !vehicleId)}
                className="prc-btn-primary w-full mt-4 inline-flex items-center justify-center gap-2"
                data-testid={`report-${kind}-btn`}
            >
                <DownloadSimple size={16} />
                {loading === kind ? "生成中…" : "PDFを生成"}
            </button>
        </div>
    );

    return (
        <div className="space-y-5" data-testid="reports-page">
            <div>
                <p className="prc-label-overline">帳票出力</p>
                <h1 className="text-[1.685rem] font-bold tracking-tight">法令対応 PDF レポート</h1>
                <p className="text-sm text-[var(--prc-muted)] mt-1">ワンクリックで点検記録簿・月次／年次レポートを出力できます。</p>
            </div>

            <div className="grid md:grid-cols-2 gap-4">
                <ReportCard kind="inspection_log" title="点検記録簿" desc="直近の使用前点検を集約したPDF。行政提出にも対応。" needsVehicle />
                <ReportCard kind="monthly" title="月次レポート" desc="点検・整備・費用を月次集計。" needsDate />
                <ReportCard kind="yearly" title="年次レポート" desc="年度単位の総合集計。" needsDate />
                <ReportCard kind="vehicle_card" title="車両カード" desc="車両台帳の個別カードPDF。" needsVehicle />
            </div>
        </div>
    );
}
